/** API de infraestructura Cash. Named exports only (no export * from leaves).
 * Reads tipados también en domain-api (para reports sin cycle).
 */

export type { CashSessionRow } from './infra/cashSessionRow';

// cashSummaryQuery
export type { CashSummary, CashDifferenceRow, CashSessionDetail } from './infra/cashSummaryQuery';
export {
  getCashSummary,
  getCashSessionDetail,
  countCashSessionsHistory,
  getCashSessionsHistory,
} from './infra/cashSummaryQuery';

// resolveCashSummary
export {
  resolveCashSummary,
  getMergedActiveCashSession,
  getMergedActiveCashSessionId,
} from './infra/resolveCashSummary';

// openCashSessionsBatchRepo
export { listBranchesWithOpenCashSession } from './infra/openCashSessionsBatchRepo';

// cashSessionChangeSignal
export {
  subscribeCashSessionChangeSignal,
  subscribeCashSessionChangeSignalDebounced,
  bumpCashSessionChangeSignal,
} from './infra/cashSessionChangeSignal';

// cashDifferencesConstants
export { CASH_DIFFERENCES_PAGE_SIZE } from './infra/cashDifferencesConstants';

// cashSummaryRemoteCache
export {
  invalidateCashSummaryCaches,
  invalidateAllCashSummaryReportsCaches,
  cashSummaryReportsCacheKey,
  cashSummaryTodayStartIso,
} from './infra/cashSummaryRemoteCache';

// cashOutflowCategories
export type { CashOutflowCategory } from './infra/cashOutflowCategories';
export {
  CASH_OUTFLOW_CATEGORIES,
  CASH_OUTFLOW_CATEGORY_LABELS,
} from './infra/cashOutflowCategories';

// cashSummaryBreakdown
export { buildCashSessionPaymentBreakdown } from './infra/cashSummaryBreakdown';

// checksRepo — cartera de cheques (Fase C). Expenses la usa para "pagar con cheque".
export type {
  CheckRow,
  CheckStatus,
  CheckSourceType,
  CheckCommandOperation,
  CheckDueBadge,
} from './infra/checksRepo';
export {
  findCustomerIdsByCheckText,
  listChecksForBranch,
  listChecksForCustomer,
  getCheckById,
  applyCheckCommand,
  mapCheckCommandError,
  CHECK_STATUS_LABELS,
  CHECK_HISTORY_STATUSES,
  checkDueBadge,
  checkDueBadgeLabel,
} from './infra/checksRepo';

// NOTE: open/close quedan internos (cashSessionsRepo) — no exportar (cycle + no callers externos).
// cashOutflowRepo / cashSessionCommandRpc: leaves allowlisted (cycle).
